<template>
    <div>
        <div class="d-flex flex-column overflow-auto cover"
             :class="full_screen ? 'full-screen' + (paramActive?' w-70 h-80':'') : ''">
            <div class="d-flex flex-row" v-if="enableButtons">
                <b-button variant="info" @click="formatJsonData">
                    <i class="fa fa-code" aria-hidden="true"></i>
                </b-button>
                <b-button variant="info" class="ml-1" @click="fullScreen">
                    <i class="fa fa-expand" aria-hidden="true"></i>
                </b-button>
                <b-button v-if="hasInputConfig" variant="info" class="ml-1" @click="$refs.jsonInput.showModal()">
                    <b-icon icon="list-nested"></b-icon>
                </b-button>
            </div>
            <div class="json-editor">
                <textarea ref="textarea"/>
            </div>
            <drawer-handler v-if="full_screen && paramActive" ref="drawer"
                            is-bottom custom-header-button-class="">
                <mini-table ref="paramTable"
                            :fields="fields" :items="params"
                            row-key="paramName"
                            read-only
                            disable-first-index-column
                            class="bg-normal"
                            @disable="getParamConfigData"></mini-table>
            </drawer-handler>
        </div>
        <div v-if="full_screen" class="back-cover" @click="full_screen = false"></div>
        <re-b-modal ref="jsonInput" :header="labelName" disable-scrollable>
            <json-input-object v-if="hasInputConfig" :value.sync="localValue" :label="labelName" :config="inputConfig"
                               is-root @changed="formatJsonData"></json-input-object>
        </re-b-modal>
    </div>

</template>

<script>
import CodeMirror from "codemirror";
import "codemirror/addon/lint/lint.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/rubyblue.css";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/sql/sql.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/lint/lint";
import "codemirror/addon/lint/json-lint";
import 'codemirror/addon/selection/active-line';
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import JsonInputObject from "@/views/report/jsonEdit/JsonInputObject";

require("script-loader!jsonlint");
export default {
    name: "jsonEditor",
    components: {JsonInputObject, ReBModal, MiniTable, DrawerHandler},
    props: {
        value: {
            type: [Object, String],
            default() {
                return {};
            },
        },
        enableButtons: {
            type: Boolean,
            default: false
        },
        enableParamConfig: {
            type: Boolean,
            default: false
        },
        inputConfig: {
            type: Array,
            default: () => []
        },
        labelName: String
    },
    computed: {
        paramActive() {
            return this.enableParamConfig && this.params.length > 0;
        },
        hasInputConfig() {
            return this.inputConfig.length > 0;
        },
    },
    data() {
        return {
            jsonEditor: null,
            localValue: this.value,

            full_screen: false,
            params: [],
            fields: [
                {key: 'paramName', label: '占位符'},
                {key: 'paramDesc', label: '参数名称', isInput: true},
                {
                    key: 'paramType', label: '参数类型', isInput: true, type: 'select',
                    options: [
                        {value: 'Text', text: '文本类型'},
                        {value: 'Time', text: '时间类型'},
                    ]
                },
                {
                    key: 'paramValue', label: '参数值', isInput: true,
                    mutativeType: [{
                        key: 'paramType',
                        value: 'Time',
                        activeType: 'select'
                    }],
                    options: [
                        {value: 'thisWeekStart', text: '本周开始'},
                        {value: 'thisWeekEnd', text: '本周结束'},
                        {value: 'lastWeekStart', text: '上周开始'},
                        {value: 'lastWeekEnd', text: '上周结束'},
                        {value: 'thisMonthStart', text: '本月开始'},
                        {value: 'thisMonthEnd', text: '本月结束'},
                        {value: 'lastMonthStart', text: '上月开始'},
                        {value: 'lastMonthEnd', text: '上月结束'},
                        {value: 'thisQuarterStart', text: '本季度开始'},
                        {value: 'thisQuarterEnd', text: '本季度结束'},
                        {value: 'lastQuarterStart', text: '上季度开始'},
                        {value: 'lastQuarterEnd', text: '上季度结束'},
                    ]
                },
            ],

            changedFlag: false,
        };
    },
    watch: {
        localValue: {
            handler() {
                this.changedFlag = true;
                this.setValue(this.localValue);
            },
            deep: true,
        }
    },
    mounted() {
        this.initJsonEditor();
    },
    methods: {
        formatJsonData() {
            if (this.localValue === null)
                this.localValue = {}
            this.setValue(this.localValue);
        },
        setValue(value) {
            this.jsonEditor.setValue(this.getJsonString(value));
        },
        initJsonEditor() {
            this.jsonEditor = CodeMirror.fromTextArea(this.$refs.textarea, {
                lineNumbers: true,
                mode: "application/json",
                gutters: ["CodeMirror-lint-markers"],
                theme: "rubyblue",
                lint: true,
                styleActiveLine: true,
                autoRefresh: true,
            });
            if (this.localValue === null)
                this.localValue = {}
            this.setValue(this.localValue);
            this.jsonEditor.on("change", cm => {
                try {
                    let temp = cm.getValue();
                    if (this.changedFlag) {//avoid infinite loop
                        this.changedFlag = false;
                    } else {
                        this.localValue = JSON.parse(temp);
                    }
                    if (this.enableParamConfig) {
                        this.searchParams(temp);
                        if (this.params.length > 0) {
                            temp = JSON.parse(temp);
                            temp.paramConfig = this.params;
                            temp = JSON.stringify(temp);
                        }
                    }
                    this.$emit("changed", temp);
                    this.$emit("input", temp);
                } catch (e) {// eslint-disable-current-line no-empty
                }
            });
            this.formatJsonData();
        },
        refresh() {
            this.jsonEditor.refresh();
        },
        getValue() {
            return this.jsonEditor.getValue();
        },
        setReadOnly(readOnly) {
            this.jsonEditor.setOption("readOnly", readOnly)
        },
        getJsonString(value) {
            if (typeof value === 'string') {
                if (!this.enableParamConfig) {
                    return value;
                }
                if (value === "") {
                    value = "{}";
                }
                value = JSON.parse(value);
            }
            if (this.enableParamConfig && Object.prototype.hasOwnProperty.call(value, 'paramConfig')) {
                this.params = value.paramConfig;
                value.paramConfig = undefined;
            }
            return JSON.stringify(value, null, 2);
        },
        fullScreen() {
            this.full_screen = !this.full_screen;
            if (this.full_screen) {
                this.formatJsonData();
            }
        },
        searchParams(str) {
            let tempList = [];
            this.getParamConfigData();
            if (str) {
                let matchResults = str.match(/\s+\?\d+/g);
                if (matchResults != null) {
                    for (let item of matchResults) {
                        item = item.trim();
                        if (this.checkParamExist(tempList, item)) {
                            continue;
                        }
                        let current = this.checkParamExist(this.params, item);
                        if (current == null) {
                            tempList.push({paramName: item, paramType: "Text", paramDesc: "", paramValue: ""});
                        } else {
                            tempList.push(current);
                        }
                    }
                }
            }
            this.params = tempList;
        },
        checkParamExist(source, paramName) {
            for (let item of source) {
                if (item["paramName"] === paramName)
                    return item;
            }
            return null;
        },
        getParamConfigData() {
            if (this.paramActive && this.$refs.paramTable) {
                this.params = this.$refs.paramTable.columnEditData();
            }
        },
    },
};
</script>

<style scoped>
.json-editor {
    height: 100%;
    margin-bottom: 10px;
}

.json-editor >>> .CodeMirror {
    height: 450px;
    font-size: 16px;
    overflow-y: hidden;
    font-weight: bold
}

.json-editor >>> .CodeMirror-scroll {
}

.json-editor >>> .cm-s-rubyblue span.cm-string {
    color: #F08047;
}

.full-screen {
    width: 60%;
    height: 60%;
    margin: auto;
    position: fixed !important;
    inset: 0;
    z-index: 9999;
}

.full-screen .json-editor >>> .CodeMirror {
    height: 100% !important;
    min-height: 300px;
}

.cover {
    transition: width, height .3s ease-out !important;
}
</style>
